import { useEffect, useState } from "react";
import { useLocation } from "@reach/router";

export function useCurrentSection() {
  const location = useLocation();

  if (!location?.pathname) {
    return undefined;
  }

  let currentSection;
  const parts = location.pathname.split("/");
  currentSection = parts.slice(0, 2).join("/");
  return currentSection;
}

export function useHasMounted() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted; 
}
